// Custom implementation of vue-jumper with fix for undefined event.key
// Original: @movilizame/vue-jumper
// Fix: Handle cases where event.key is undefined

export default {
    bind(el, binding, vnode) {
        const jumpToNext = () => {
            const inputs = Array.from(
                document.querySelectorAll('input, button, textarea, select')
            ).filter(input => {
                return (
                    !input.disabled &&
                    !input.readOnly &&
                    input.tabIndex >= 0 &&
                    input.offsetParent !== null
                );
            });

            const currentIndex = inputs.indexOf(el);
            if (currentIndex > -1 && currentIndex < inputs.length - 1) {
                const nextInput = inputs[currentIndex + 1];
                nextInput.focus();
                if (nextInput.select && typeof nextInput.select === 'function') {
                    nextInput.select();
                }
            }
        };

        const handleKeydown = (event) => {
            // Fix: Check if event.key exists before calling toUpperCase
            if (!event || !event.key) {
                return;
            }

            const key = event.key.toUpperCase();
            
            if (key === 'ENTER') {
                event.preventDefault();
                jumpToNext();
            }
        };

        el._jumpHandler = handleKeydown;
        el.addEventListener('keydown', handleKeydown);
    },

    unbind(el) {
        if (el._jumpHandler) {
            el.removeEventListener('keydown', el._jumpHandler);
            delete el._jumpHandler;
        }
    }
};
